import PropTypes from 'prop-types';
import React from 'react';

import UserAvatar, {
  AVATAR_SIZES
} from 'dpl/path_to_payment/components/UserAvatar';

export default function ProfileAvatar({
  breederUserId,
  breederUserInitials,
  breederProfilePhotoUrl,
  className,
  puppyProfilePhotoUrl,
  size
}) {
  return (
    <UserAvatar
      className={className}
      size={size}
      user={{
        id: breederUserId,
        initials: breederUserInitials,
        profile_photo_url: puppyProfilePhotoUrl || breederProfilePhotoUrl
      }}
    />
  );
}

ProfileAvatar.propTypes = {
  breederUserId: PropTypes.number.isRequired,
  breederUserInitials: PropTypes.string.isRequired,
  breederProfilePhotoUrl: PropTypes.string,
  className: PropTypes.string,
  puppyProfilePhotoUrl: PropTypes.string,
  size: PropTypes.oneOf(Object.keys(AVATAR_SIZES))
};

ProfileAvatar.defaultProps = {
  breederProfilePhotoUrl: null,
  className: null,
  puppyProfilePhotoUrl: null,
  size: null
};
